<template>
  <div class="ted-container">
    <div class="d-flex flex-column form-group mb-3">
        <label class="small-label">Valor</label>
        <label class="price-label">
          {{
            destination.amount
              | currency('R$ ', 2, {
                decimalSeparator: ',',
                thousandsSeparator: '.',
              })
          }}
        </label>
    </div>
    <div class="d-flex flex-column form-group mb-2">
        <label class="small-label">
          {{destination.isRecurrence ? 'Primeira transferência em' : 'Pagar em'}}
        </label>
        <div>
          <em class="icon-calendar calendar mr-2"/>
          <label class="mr-2">{{ formattedStartDate() }}</label>
          <label v-if="startDateIsToday()">(Agora)</label>
        </div>
    </div>
    <div v-if="destination.isRecurrence" class="d-flex flex-column form-group mb-2">
        <label class="small-label">
          A cada
        </label>
        <div>
          <em class="icon-calendar calendar mr-2"/>
          <label> {{ frequencyMap[destination.frequency] }} </label>
        </div>
    </div>
    <div v-if="destination.isRecurrence" class="d-flex flex-column form-group mb-3">
        <label class="small-label">
          Terminando em
        </label>
        <div>
          <em class="icon-calendar calendar mr-2"/>
          <label>{{ formattedEndDate() }}</label>
        </div>
    </div>
    <div class="d-flex form-group">
        <label class="small-label-destination">Destino</label>
    </div>
    <div class="d-flex form-group">
        <label class="small-label-destination">
          {{ destination.details.account.name }}
        </label>
    </div>
    <div class="d-flex form-group">
        <label class="small-label-destination">
          {{ destination.details.account.taxDocument }}
        </label>
    </div>
    <div v-if="destination.details.account.branch" class="d-flex form-group">
        <label class="small-label-destination">
          <strong class="small-label-destination">Agência:</strong>
        </label>
        <label class="small-label-destination">{{ destination.details.account.branch }}</label>
    </div>
    <div v-if="destination.details.account.branch" class="d-flex form-group">
      <label class="small-label-destination">
        <strong class="small-label-destination">
          Conta
          {{ getAccountType(destination.details.account.type) }}:
        </strong>
      </label>
      <label class="small-label-destination">
        {{ destination.details.account.number }}
      </label>
    </div>

    <div class="d-flex form-group">
        <label class="small-label-destination">
          {{ destination.details.account.institutionName }}
        </label>
    </div>
    <div class="row mb-2">
      <div class="col-6">
          <WhiteLabel>
              <button type="button" @click="returnStep()" class="btn btn-md col-12">
                  Voltar
              </button>
          </WhiteLabel>
      </div>
      <div class="col-6">
          <WhiteLabel>
              <button type="button"
                  class="btn btn-md col-12 btn-orange"
                  @click="confirm()">
                  Continuar
              </button>
          </WhiteLabel>
      </div>
    </div>
  </div>
</template>

<script>
import WhiteLabel from '@/components/shared/WhiteLabel';
import moment from 'moment';

export default {
  name: 'ConfirmPixTransferModalSection',

  components: {
    WhiteLabel,
  },
  props: {
    destination: {
      type: Object,
      required: true,
      default: () => {
        return {
          label: '',
          amount: '',
          prefix: '',
          id: '',
          icon: '',
          details: {
            account: {},
          },
          isRecurrence: false,
          frequency: null,
          startDate: null,
          endDate: null,
        };
      },
    },
  },

  data: () => ({
    frequencyMap: {
      'weekly': 'Semana',
      'biweekly': 'Quinzena',
      'monthly': 'Mês',
      'quarterly': 'Trimestre',
      'sixmonthly': 'Semestre',
      'yearly': 'Ano',
    },
  }),
  methods: {
    getAccountType(accountType) {
      switch (accountType) {
        case 'checking':
          return 'corrente';
        case 'savings':
          return 'poupança';
        case 'salary':
          return 'salário';
        case 'payment-account':
          return 'pagamento';

        default:
          break;
      }
    },
    confirm() {
      this.$emit('confirm');
    },
    returnStep(){
      this.$emit('return-step');
    },
    formattedStartDate() {
      return moment(this.destination.startDate).format('DD/MM/YYYY');
    },
    formattedEndDate() {
      return moment(this.destination.endDate).format('DD/MM/YYYY');
    },
    startDateIsToday(){
      return moment(this.destination.startDate).isSame(moment(), 'day');
    },
  },
};
</script>

<style lang="scss" scoped>
.ted-container {
  padding: 0px 1.6rem;
}
.input-money {
  font-size: 48px;
  max-width: 100%;
  border: none;
  outline: none;
  font-weight: lighter;
  border-bottom: solid thin;
  border-color: #a1a4b1;
}

.mt-lg {
  margin-top: 80px;
}
.small-label {
  display: block;
  text-transform: uppercase;
  color: #7d8287;
  font-size: 12px;
}
.small-label-destination{
  color: #7d8287;
  font-size: 13px;
}
.price-label {
  display: block;
  font-size: 30px;
  color: #7d8287;
}
.small-price-label {
  display: block;
  color: #7d8287;

  &--inline {
    display: inline;
  }
}
.icon-small {
  width: 20px;
  height: 20px;
}
</style>
